import { Component, Input, OnInit, AfterViewInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import * as _ from "lodash";
import { KreFormIonToastService } from "../tools/toast.service";
@Component({
  selector: "kreform-field-ion-i18",
  template: `
    <ion-header class="contactHeader">
      <ion-toolbar>
        <ion-title> 多语言设置</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ng-container *ngIf="editor == true; else other">
        <div *ngFor="let item of languageList">
          <ion-label>
            <span *ngIf="required == true" class="required-icon">*</span>
            {{ item.label }}</ion-label
          >
          <ion-item>
            <ion-input [(ngModel)]="item.value"></ion-input>
          </ion-item>
        </div>
      </ng-container>
      <ng-template #other>
        <div class="fieldtext">
          <div *ngFor="let item of languageList">
            <ion-label>{{ item.label }}</ion-label>
            <ion-item>
              {{ item.value }}
            </ion-item>
          </div>
        </div>
      </ng-template>
      <div class="selection-buttons">
        <div class="buttons-between">
          <ion-button size="small" (click)="dismissModel(false)"
            >取消</ion-button
          >
          <ion-button
            [disabled]="!editor"
            size="small"
            (click)="dismissModel(true)"
            >确定</ion-button
          >
        </div>
      </div>
    </ion-content>
  `,
})
export class KreFormFieldIonTextI18Component implements OnInit, AfterViewInit {
  _languageList: any;
  _languageList_old: any;
  @Input() editor = true;
  @Input() required = false;
  @Input()
  public get languageList(): any {
    return this._languageList;
  }
  public set languageList(value: any) {
    this._languageList = _.cloneDeep(value);
    this._languageList_old = value;
  }

  constructor(
    public modalController: ModalController,
    public toastService: KreFormIonToastService
  ) {}

  // 0 取消 / 1 确定
  dismissModel(type) {
    let result: any;
    if (type) {
      result = this.languageList;
      if (this.required == true) {
        let languageEmpty = result.filter((item: any) => {
          if (item.value == null || item.value == "") {
            return item;
          }
        });
        if (languageEmpty != null && languageEmpty.length > 0) {
          this.toastService.presentToast("多语言字段不能为空!");
          return;
        }
      }
      this.modalController.dismiss(result);
    } else {
      this.modalController.dismiss();
    }
  }

  ngOnInit() {}

  ngAfterViewInit() {}
}
